import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="section" id="about">
      <div>
        <div className="section-header">About</div>
        <p className="section-text">
          I’m a Computer Science undergraduate in my senior year. I'm a full
          stack web developer and aspire to be a web3 developer someday. What I
          do to get closer to those goals is continuously challenge my self in
          creating side projects and learning about new things ever so often. I
          also love problem-solving and approaching challenging tasks with a
          can-do attitude.
        </p>
      </div>
    </div>
  );
};

export default About;
